import { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

interface IMapToolsWrapper {
  children?: ReactNode;
}

const TcMapRightToolsWrapper: FC<IMapToolsWrapper> = ({ children }) => {
  //state
  const { fullScreen } = useSelector((state: RootState) => state.setting);

  return (
    <div className={`absolute flex flex-col gap-2 transition-all duration-500 opacity-80 hover:opacity-100 right-4 ${fullScreen ? 'top-1/2 translate-y-1/2' : 'top-12 '}`}>
      {children}
    </div>
  );
};

export default TcMapRightToolsWrapper;
